"use strict";

import angular from "angular";

import { Events } from "../../../presentation/services/Events/Events";
import oneMillionShareDialogTemplate from "../one-million-share/one-million-share-dialog.html";

class OneMillionProgressDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService, $state, $scope) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.$scope = $scope;

        this.impacts = locals.impacts;

        this.Events = new Events();
    }

    $onInit() {
        this.Events.send("popup.onboarding.compartilharmissao");
    }

    onShareMission() {
        this.$mdDialog.cancel();

        const statusImpact = !this.impacts?.companiesIdsImpact?.length
            ? 0
            : this.impacts?.companiesIdsImpact?.length;

        this.DSNDialogService.custom({
            controller: "OneMillionShareDialogCtrl as $ctrl",
            clickOutsideToClose: true,
            locals: {
                accountingData: this.locals.accountingData,
                status: statusImpact
                    ? this.impacts?.currentImpactLevel?.status?.toLowerCase() ||
                      "bronze"
                    : false,
                width: "auto",
                title: "Compartilhe a Missão",
                templateHtml: oneMillionShareDialogTemplate
            },
            after: {
                cancel: () => {},
                hide: () => {
                    this.locals.updateFlagMission();
                }
            }
        });
    }

    onOpenSideNav() {
        this.$mdDialog.hide("openSideNav");
    }
}

angular
    .module("nucont.shared")
    .controller("OneMillionProgressDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        "$state",
        "$scope",
        OneMillionProgressDialogCtrl
    ]);
